export enum ConsentState {
  Accepted = 'Accepted',
  Revoked = 'Revoked',
  NotSet = 'NotSet',
}
